import { useState, useEffect } from 'react'

const storageKeyFor = (key: string) => `pagination:${key}`

export function usePersistedState<T>(key: string, defaultValue: T) {
  const [state, setState] = useState<T>(() => {
    try {
      const raw = sessionStorage.getItem(storageKeyFor(key))
      return raw !== null ? JSON.parse(raw) : defaultValue
    } catch {
      return defaultValue
    }
  })

  useEffect(() => {
    try {
      sessionStorage.setItem(storageKeyFor(key), JSON.stringify(state))
    } catch {}
  }, [key, state])

  return [state, setState] as const
}